import { useEffect, useMemo } from "react";
import { useCurrentTaxFilingYear } from "../utils/useCurrentTaxFilingYear";
import {
  createTaxFormSubmissionListRequest,
  getTaxFormSubmissionViewDefaultFilters
} from "../../../query/search/taxForm/queries/filtering";
import { TaxFormSubmissionRequest } from "../../../services/search";
import { useQueryTaxFormSubmissionRowsSummary } from "../../../query/search/taxForm/queries/useQueryTaxFormSubmissionRowsSummary";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPayrollSettings } from "../../../query/payments/queries";
import { selectorCurrentYearFilingSettingsEnabled } from "../selectors/selectorCurrentYearFilingSettingsEnabled";
import { useOptInTaxFilling } from "../components/ModalOptInTaxFilling";

let isModalOpened: Record<number, boolean> = {};

export const useIsTaxFilingDashboardEnabled = () => {
  const currentYear = useCurrentTaxFilingYear();

  const userId = useUserId();

  const defaultFilters = getTaxFormSubmissionViewDefaultFilters();

  const optInCurrentYearFilling = useOptInTaxFilling();

  const currentRequest = useMemo((): TaxFormSubmissionRequest => {
    return createTaxFormSubmissionListRequest(currentYear, defaultFilters);
  }, [currentYear]);

  const queryPayrollSettings = useQueryPayrollSettings(userId);

  const queryTaxFormSubmissionRowsSummary =
    useQueryTaxFormSubmissionRowsSummary(currentRequest);

  const isLoading =
    !queryPayrollSettings.isFetched ||
    !queryTaxFormSubmissionRowsSummary.isFetched;

  const isFilingEnabled =
    queryPayrollSettings.data &&
    selectorCurrentYearFilingSettingsEnabled(
      queryPayrollSettings.data,
      currentYear
    );

  const isEnabled =
    isFilingEnabled &&
    queryTaxFormSubmissionRowsSummary.data &&
    queryTaxFormSubmissionRowsSummary.data.listSize > 0;

  useEffect(() => {
    if (!isModalOpened[currentYear] && !isLoading && !isFilingEnabled) {
      isModalOpened[currentYear] = true;
      optInCurrentYearFilling(currentYear);
    }
  }, [isLoading, isFilingEnabled, currentYear]);

  return {
    isLoading,
    isEnabled
  };
};
